import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import StrategyList from '@app/views/ProjectStrategy/List';
import { memo } from 'react';

export default memo(
  withIfUser(StrategyList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
